<template>
  <el-select
    :value="value"
    :multiple="multiple"
    :multiple-limit="limit"
    @change="handlerChange"
    clearable
    filterable
    :disabled="readonly"
    style="width: 100%"
    placeholder="请选择"
  >
    <el-option
      v-for="item in list"
      :key="item.code"
      :label="item.name"
      :value="item[need]"
    >
      {{ item.name }}
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: {},
    multiple: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 0,
    },
    need: {
      type: String,
      default: "code",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    url: {},
    code: {},
    name: {},
  },
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    url() {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.$get(this.url).then((r) => {
        this.list = r.Result.map((m) => {
          return {
            code: m[this.code],
            name: m[this.name],
          };
        });
      });
    },
    handlerChange(v) {
      this.$emit("input", v);
    },
  },
};
</script>

<style></style>
